<template>
  <IconLucideClock />
</template>
